import type { Location } from 'react-router-dom'

export enum LoginRoutePathsEnum {
  LOGIN = '/login',
}

export type LoginLocationState = {
  from?: Location
  fromLogin?: boolean
}
